import React from 'react'

import { fonts, mediaQueries } from '../../../../styles/variables'
import FlipClock from '../../../flipClock'

import { AppBannerCounterStyled } from './styled'

export const AppBannerCounter = ({ endDate, theme, onTimeOver }) => {
  return (
    <AppBannerCounterStyled>
      <FlipClock
        endDate={endDate}
        onTimeOver={onTimeOver}
        card={{
          boxShadow: '0px 4px 14px 0px rgba(255, 94, 41, 0.10)',
          height: 36,
          width: 26,
          gap: 10,
          [mediaQueries.smallDesktop]: {
            height: 36,
            width: 26,
          },
          [mediaQueries.mobile]: {
            height: 28,
            width: 22,
          },
          [mediaQueries.smallMobile]: {
            height: 36,
            width: 26,
          },
          ...theme?.counter?.card,
        }}
        divider={{
          fontFamily: fonts.primary,
          ...theme?.counter?.divider,
        }}
        label={{
          fontFamily: fonts.primary,
          fontSize: '10px',
          ...theme?.counter?.label,
        }}
        text={{
          fontSize: '16px',
          lineHeight: '16px',
          ...theme?.counter?.text,
        }}
      />
    </AppBannerCounterStyled>
  )
}
